<div class="example-container">
  <mat-stepper #stepper>
    <mat-step [stepControl]="invoiceSetupForm" errorMessage="Missing values, please check and fill them">
      <ng-template matStepLabel>Company Data</ng-template>
      <form [formGroup]="invoiceSetupForm">
        <mat-form-field appearance="fill" style="margin-top: 30px; align-content: center;">
          <mat-label>Contract id </mat-label>
          <mat-select (selectionChange)="selectContract($event.value)">
            <mat-option *ngFor="let contract of contracts" [value]="contract.id">
              {{contract.id}} - {{contract.title}}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field appearance="fill" style="margin: 20px;">
          <mat-label>Description</mat-label>
          <input formControlName="description" matInput #input maxlength="50" placeholder="Ex. Contract">
        </mat-form-field>
        <mat-divider></mat-divider>
        <h1 style="margin-top: 20px;"> Company Data </h1>
        <h3 style="margin-left: 2%;">Company adress: {{company.companyAddress}}</h3>
        <mat-form-field appearance="fill" style="margin: 20px;">
          <mat-label>Billing address </mat-label>
          <input formControlName="addressLine1" matInput #input maxlength="50" placeholder="Ex. Via Roma 12">
          <mat-error *ngIf="invoiceSetupForm.controls.addressLine1?.errors?.required">
            Field <strong>required</strong>
          </mat-error>
        </mat-form-field>
        <mat-form-field appearance="fill" style="margin: 20px;">
          <mat-label>City </mat-label>
          <input formControlName="city" matInput #input maxlength="50" placeholder="Ex. Rome">
          <mat-error *ngIf="invoiceSetupForm.controls.city?.errors?.required">
            Field <strong>required</strong>
          </mat-error>
        </mat-form-field>
        <mat-form-field appearance="fill" style="margin: 20px;">
          <mat-label>Country </mat-label>
          <input formControlName="country" matInput #input maxlength="50" placeholder="Ex. Italy">
          <mat-error *ngIf="invoiceSetupForm.controls.country?.errors?.required">
            Field <strong>required</strong>
          </mat-error>
        </mat-form-field>
        <mat-form-field appearance="fill" style="margin: 20px;">
          <mat-label>ZipCode </mat-label>
          <input formControlName="zipCode" matInput #input maxlength="50">
          <mat-error *ngIf="invoiceSetupForm.controls.zipCode?.errors?.required">
            Field <strong>required</strong>
          </mat-error>
        </mat-form-field>
        <mat-form-field appearance="fill" style="margin: 20px;">
          <mat-label>Email </mat-label>
          <input formControlName="email" type="email" matInput placeholder="Ex. pat@example.com">
          <mat-error
            *ngIf="invoiceSetupForm.controls.email?.errors?.email && !invoiceSetupForm.controls.email?.errors?.required">
            Please enter a valid email address
          </mat-error>
          <mat-error *ngIf="invoiceSetupForm.controls.email?.errors?.required">
            Field <strong>required</strong>
          </mat-error>
        </mat-form-field>
        <mat-form-field appearance="fill" style="margin: 20px;">
          <mat-label>Identifier </mat-label>
          <input formControlName="identifier" matInput #input maxlength="50">
          <mat-error *ngIf="invoiceSetupForm.controls.identifier?.errors?.required">
            Field <strong>required</strong>
          </mat-error>
        </mat-form-field>
        <mat-form-field appearance="fill" style="margin: 20px;">
          <mat-label>PEC</mat-label>
          <input formControlName="pec" matInput #input maxlength="50" placeholder="Ex. pat@example.com">
          <mat-error
            *ngIf="invoiceSetupForm.controls.pec?.errors?.email && !invoiceSetupForm.controls.pec?.errors?.required">
            Please enter a valid email address
          </mat-error>
          <mat-error *ngIf="invoiceSetupForm.controls.pec?.errors?.required">
            Field <strong>required</strong>
          </mat-error>
        </mat-form-field>
        <mat-form-field appearance="fill" style="margin: 20px;">
          <mat-label>Phone</mat-label>
          <input formControlName="phone" matInput #input maxlength="50" value="{{company.contact1phone}}">
          <!-- problemi con validator angular non risolti -->
          <!-- <mat-error *ngIf="invoiceSetupForm.controls.phone?.errors?.required">
            Field <strong>required</strong>
          </mat-error> -->
        </mat-form-field>
        <mat-form-field appearance="fill" style="margin: 20px;">
          <mat-label>Vat Number </mat-label>
          <input formControlName="vatNumber" matInput #input maxlength="50">
          <mat-error *ngIf="invoiceSetupForm.controls.vatNumber?.errors?.required">
            Field <strong>required</strong>
          </mat-error>
        </mat-form-field>
        <mat-form-field appearance="fill" style="margin: 20px;">
          <mat-label>SDI Code </mat-label>
          <input formControlName="codeSDI" matInput #input maxlength="50">
          <mat-error *ngIf="invoiceSetupForm.controls.codeSDI?.errors?.required">
            Field <strong>required</strong>
          </mat-error>
        </mat-form-field>
        <div>
          <button mat-button matStepperNext>Next</button>
        </div>
      </form>
    </mat-step>

    <mat-step errorMessage="Description and unitCost are required">
      <!------------------------- init insert item ---------------------------------->
      <form>
        <ng-template matStepLabel>Invoice Item</ng-template>
        <mat-card appearance="outlined">

          <button mat-raised-button (click)="show()">
            <mat-icon color="accent">add</mat-icon> Add New Item
          </button>

        </mat-card><br>

        <div *ngIf="showTable">
          <!-- ----------------------------Add user table----------------------------------->

          <table mat-table [dataSource]="dataSourceItemToAdd">
            <!-- Description Column -->
            <ng-container matColumnDef="description">
              <th mat-header-cell *matHeaderCellDef> Description</th>
              <td mat-cell *matCellDef="let element">
                <mat-form-field >
                  <input matInput placeholder="Enter description" [value]="element.description"
                    [(ngModel)]="element.description" [formControl]="description" required>
                  <mat-error *ngIf="description.invalid">{{getErrorMessage()}}</mat-error>
                </mat-form-field>
              </td>
            </ng-container>

            <!-- unitCost Column -->
            <ng-container matColumnDef="unitCost">
              <th mat-header-cell *matHeaderCellDef> UnitCost</th>
              <td mat-cell *matCellDef="let element">
                <mat-form-field >
                  <input matInput placeholder="price" min="0" type="number" [value]="element.unitCost"
                    [(ngModel)]="element.unitCost" required [formControl]="unitCost">
                  <mat-error *ngIf="unitCost.invalid">{{getErrorMessage()}}</mat-error>
                </mat-form-field>
              </td>
            </ng-container>
            <!-- Save Column -->
            <ng-container matColumnDef="Save">
              <th mat-header-cell *matHeaderCellDef> </th>
              <td mat-cell *matCellDef="let element">
                <button mat-raised-button (click)="addItem(element)"
                  [disabled]="description.invalid || unitCost.invalid">
                  <mat-icon color="accent">save</mat-icon>
                  Save
                </button>
              </td>
            </ng-container>

            <!-- Cancel Column -->
            <ng-container matColumnDef="Cancel">
              <th mat-header-cell *matHeaderCellDef> </th>
              <td mat-cell *matCellDef="let element">
                <button mat-raised-button (click)="cancel()">
                  <mat-icon color="accent">cancel</mat-icon> Cancel
                </button>
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumnsAddItem"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumnsAddItem;"></tr>
          </table>
        </div>
        <br><br>
        <!-----------------Item Table ----------------------------->
        <div class="mat-elevation-z8">
          <table mat-table [dataSource]="dataSourceItems" matSort class="mat-elevation-z8">

            <!-- Name Column -->
            <ng-container matColumnDef="description">
              <th mat-header-cell *matHeaderCellDef mat-sort-header> Item </th>
              <td mat-cell *matCellDef="let element">
                <mat-form-field >
                  <input matInput placeholder="Item" [value]="element.description">
                </mat-form-field>
              </td>
            </ng-container>

            <!-- Surname Column -->
            <ng-container matColumnDef="unitCost">
              <th mat-header-cell *matHeaderCellDef mat-sort-header> Price </th>
              <td mat-cell *matCellDef="let element">
                <mat-form-field >
                  <input matInput type="number" min="0" placeholder="Price" [value]="element.unitCost">
                </mat-form-field>
              </td>
            </ng-container>


            <!-- Change Column -->
            <ng-container matColumnDef="Change">
              <th mat-header-cell *matHeaderCellDef> </th>
              <td mat-cell *matCellDef="let element">

              </td>
            </ng-container>

            <!-- Delete Column -->
            <ng-container matColumnDef="Delete">
              <th mat-header-cell *matHeaderCellDef> </th>
              <td mat-cell *matCellDef="let element">
                <button mat-raised-button (click)="deleteItem(element)">
                  <mat-icon color="accent">delete</mat-icon> Delete
                </button>
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="headers"></tr>
            <tr mat-row *matRowDef="let row; columns: headers;"></tr>
          </table>

          <mat-paginator [pageSizeOptions]="[5, 10, 25, 100]"></mat-paginator>
        </div>
        <br><br>
        <div>
          <button mat-button matStepperPrevious>Back</button>
          <button mat-button matStepperNext>Next</button>
        </div>
      </form>
    </mat-step>
    <mat-step>
      <ng-template matStepLabel>Done</ng-template>
      <p>Click save to confirm this Setup</p>
      <div>
        <button mat-button matStepperPrevious>Back</button>
        <button mat-button [disabled]="!invoiceSetupForm.valid" (click)="saveInvoiceSetup()">Save</button>
      </div>
    </mat-step>
  </mat-stepper>

</div>